import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const faqApiService = createApi({
  reducerPath: "faqApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getFAQ: builder.query({
      query: ({ id, params }) => {
        let url = id ? `faq/${id}` : `faq/get`;
        const query = queryParams(params);
        return `${url}${query}`;
      },
    }),
  }),
});

export const { useGetFAQQuery } = faqApiService;
